/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';
import page from 'page';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import SelectDispatchPlan from 'modules/me/select-dispatch-plan';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import AnnotatedSection from 'components/annotated-section';
import Notice from 'components/notice';
import { getBusinessName } from 'state/current-user/selectors';

/**
 * Style dependencies
 */
import './styles.scss';


const NewPlan = ({ businessName }) => {
    
    const onSuccessPlanSelect = () => {
        page.redirect('/dashboard/dispatch');
    };

    return (
        <Box>
            <DocumentHead title='Billing - Tower Systems' />
            <Topbar title='Dispatch Module' subTitle={'Hello ' + businessName} selected='dispatch' />
            <Box marginBottom='xxlarge'>
                <Text className="plan__content">
                    This brand new facility, designed for those customers that deliver goods, 
                    allows you to schedule delivery of products on a designated resource or 
                    delivery vehicle. You can easily see the deliveries for each day on a 
                    Google map and print out a delivery list for your drivers. 
                </Text>
            </Box>
            <Main padding='xxlarge'>
                <Stack space='xxlarge'>
                    <Box>
                        <Heading level='3'>Select a Dispatch Module plan</Heading>
                        <Text>
                            *Prices are excluding any applicable discounts. Please click on a plan below to subscribe.
                        </Text>
                    </Box>
                    <Box>
                        <SelectDispatchPlan afterSuccess={onSuccessPlanSelect} />
                    </Box>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect((state) => ({businessName: getBusinessName(state),}), {})(NewPlan);
